import { EventEmitter } from "events";
import TCVelikClient from '@/TCVelikClient/TCVelikClient.js'

class TagsService extends EventEmitter {

    TC_API_BASE_URL = process.env.VUE_APP_API_URL + "/";

    getTags(filter){
        var filterQuery = (filter && filter.length > 0 ? "?filter=" + filter : "");
        return TCVelikClient.GetRelative(`/api/Tags/Get${filterQuery}`);
    }

    GetDetails(tagId){
      var tagIdStr = tagId ? tagId : "";
      return TCVelikClient.GetRelative(`/api/Tags/GetDetails?tagId=${tagIdStr}`);
    }

    GetForTrackAndSeniority(position, userId){
      if (!userId)
        userId = '';

      return TCVelikClient.GetRelative(`/api/Tags/GetForTrackAndSeniority?position=${position}&userId=${userId}`)
    }

    commitTags(tags){
        var query = {
            "items": tags
        }
        return TCVelikClient.PostRelative("/api/Tags/SaveBulk", query);
    }

    deleteBulk(items){
      return TCVelikClient.PostRelative("/api/Tags/DeleteBulk", items);
    }

    save(tag){
        return TCVelikClient.PostRelative("/api/Tags/Save", tag);
    }
}
export default new TagsService();
